<template lang="pug">
    v-container.custom-container(style="z-index:999;")
        v-toolbar(v-if="inDialog" color="primary" dark flat="")
            v-spacer
            v-btn(icon="" @click="$emit('close')")
                  v-icon mdi-close
        v-layout.terms-wrapper(column align-center)
            v-tabs(v-model="tab" background-color="primary" dark icons-and-text show-arrows)
              v-tab(v-if="item.type === 'Interes'" v-for="(item,index) in policies" :key="item.id" :href="`#tab-${index}`" @click="goTostatic(item)")
                | {{ item.title }}
            v-tabs-items(v-model="tab" style="max-height: 67vh; overflow-y: auto; width: 100%" light)
              span(v-for="(item,index) in policies")
                v-tab-item(:key="item.id" :value="'tab-' + index")
                  v-card(flat="")
                    v-skeleton-loader.mx-auto(v-if="isLoading" ref="skeleton" type="card-avatar")
                    static(v-else)
</template>

<script>
  export default {
    components: {
      static: () => import('@/views/custom/CMS/Statics'),
    },
    props: {
      openTab: {
        type: Number,
        default: 2,
      },
      inDialog: {
        type: Boolean,
        default: false,
      },
    },
    data () {
      return {
        title: 'Terms and Conditions',
        isLoading: false,
      }
    },
    computed: {
      policies () {
        return this.$store.getters['cms/getStatic']
      },
      tab () {
        return `tab-${+this.openTab}`
      },
    },
    mounted () {
      // console.log(this.tab)
    },
    methods: {
      goTostatic (item) {
        const vm = this
        vm.isLoading = true
        vm.$store.dispatch('cms/getItem', { context: 'static', id: item.id }).then(function () {
          vm.isLoading = false
        })
      },
    },
  }
</script>

<style lang='scss' scoped>
.terms-wrapper{
  li {
    text-align: justify;
    padding: .25rem 0;
  }
}
</style>
